// src/components/title-upload-status.js

import React from 'react';

const TitleUploadStatus = (props) => {
var imagesrc = '/img/docstack_red.svg'
var hovertext = 'No files uploaded - not yet marked complete' 

if (props.filesUploaded){
  var imagesrc = '/img/docstack_green.svg'
  var hovertext = 'Files uploaded - marked complete'
}
else{
  if (props.filesAttached > 0){
    var imagesrc = '/img/docstack_yellow.svg'
    var hovertext = 'Files uploaded - not yet marked complete'
  }
  else {
    var imagesrc = '/img/docstack_red.svg'
    var hovertext = 'No files uploaded - not yet marked complete'   
  }
}


  return (
    <img src={imagesrc} title={hovertext} id="myId" width='40' height='40'/>
  );
};

export default TitleUploadStatus;